interface NameCellProps {
  name: string
  href?: string
  onClick?: () => void
}

export function NameCell({ name, href, onClick }: NameCellProps) {
  const className = 'text-sm text-primary'

  if (href) {
    return (
      <div className="flex h-7 items-center">
        <a href={href} className={`${className} hover:underline`}>
          {name}
        </a>
      </div>
    )
  }

  if (onClick) {
    return (
      <div className="flex h-7 items-center">
        <button
          type="button"
          onClick={onClick}
          className={`${className} cursor-pointer hover:underline`}
        >
          {name}
        </button>
      </div>
    )
  }

  return (
    <div className="flex h-7 items-center">
      <span className={className}>{name}</span>
    </div>
  )
}
